import sam7 from '../../assets/sam8.webp';
import styles from './MediaHero.module.css';

const MediaHero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.imageContainer}>
        <img src={sam7} alt="Media Hero" />
      </div>
      <div className={styles.textContainer}>
        <p className={styles.intro}>WELCOME TO MY MEDIA HUB</p>
        <h1 className={styles.heading}>
          every performance, every song <br />
          every frame holds a piece of my story.
        </h1>
        <p className={styles.goal}>
          from music and acting to the moments in between—this is where I share my heart. thank you for being here.
        </p>
      </div>
    </section>
  );
};

export default MediaHero;
